export interface InstallationDetailTab {
  title: string;
  route: string;
  // A tab whose feature the caller lacks is left out rather than rendered to fail.
  permission?: string;
}

export const INSTALLATION_DETAIL_TABS: InstallationDetailTab[] = [
  { title: 'installations.detailTabs.general', route: 'general' },
  {
    title: 'installations.detailTabs.insights',
    route: 'insights',
    permission: 'view_installation_telemetry',
  },
  {
    title: 'installations.detailTabs.dataSources',
    route: 'data-sources',
    permission: 'view_installations',
  },
  // Reads the alarms of the devices that feed the installation.
  {
    title: 'installations.detailTabs.alarms',
    route: 'alarms',
    permission: 'view_device',
  },
  {
    title: 'installations.detailTabs.activity',
    route: 'activity',
    permission: 'view_installations',
  },
  // Like General, open to whoever may open the page; each section in it keeps its own gate.
  { title: 'installations.detailTabs.settings', route: 'settings' },
];
